import React from 'react';
import { AbsoluteFill } from 'remotion';
import { CompositorLayer } from '../../types/layers';
import { VideoSegment } from './VideoSegment';

interface ScreenLayerProps {
  layer: CompositorLayer;
}

export const ScreenLayer: React.FC<ScreenLayerProps> = ({ layer }) => {
  if (!layer.visible) {
    return null;
  }

  return (
    <AbsoluteFill style={{ zIndex: layer.zIndex, opacity: layer.opacity ?? 1 }}>
      {layer.segments.map(segment => (
        <VideoSegment
          key={segment.segmentId}
          segment={segment}
        />
      ))}
    </AbsoluteFill>
  );
};
